import { P } from "../../../components/Common/Typo/typo";
import ThaihealthBuilding from "../../../assets/thaihealthbuilding.png";
import React from "react";
import { EachFloorCard } from "./Card";
import dayjs from "dayjs";
import "dayjs/locale/th";

const FloorCard = ({ card_data, title, isWaste, date=dayjs() }: any) => {
  let thaiDate;
  dayjs.locale("th");
  if (isWaste) {
    thaiDate = date.subtract(1, "month").format("MMMM YYYY");
  } else {
    thaiDate = date.locale("th").format("MMMM YYYY");
  }

  return (
    <div className="relative p-[10px] rounded-xl border border-[#EDEFF9] bg-white shadow-cardborder h-full flex flex-col gap-[12px]">
      <div className="flex items-center justify-between">
        <P fontSize="30px" fontWeight="700" color="#1D1D1C">
          {title}
        </P>
        <div className="px-[8px] rounded-md border border-[#DADADA] bg-[#EFEFEF]">
          <P fontSize="20px" fontWeight="700" color="#6F6F6E">
            ข้อมูลล่าสุด: {thaiDate}
          </P>
        </div>
      </div>
      <img
        src={ThaihealthBuilding}
        alt="ThaihealthBuilding"
        className="h-full object-contain"
      />
      {card_data.map((data: any, index: number) => (
        <EachFloorCard
          key={index}
          title={data.title}
          value={data.value}
          unit={data.unit}
          top={data.top}
          left={data.left}
        />
      ))}
    </div>
  );
};

export default FloorCard;
